import { LANGUAGE_CODES } from './settings'

export function normalizeUiLanguage(raw, fallback = 'en') {
    if (!raw) return fallback
    const code = String(raw).trim().toLowerCase().replace('_', '-')
    if (code === 'en-us' || code === 'en-gb') return 'en'
    const short = code.split('-')[0]
    if (short === 'cz' || short === 'cs') return 'cs'
    if (short === 'uk') return 'ua'
    return short || fallback
}

export function toBackendLanguage(raw, fallback = 'en-us') {
    const ui = normalizeUiLanguage(raw, '')
    if (!ui) return fallback
    if (ui === 'en') return 'en-us'
    return ui
}

export function languageLookupKeys(raw) {
    const ui = normalizeUiLanguage(raw, '')
    if (!ui) return []
    if (ui === 'cs') return ['cs', 'cz']
    return [ui]
}

export function languageI18nKey(code) {
    const ui = normalizeUiLanguage(code, '')
    return ui ? `language_${ui}` : ''
}

export function remapLocalizedMapKeys(value) {
    if (!value || typeof value !== 'object' || Array.isArray(value)) return value || {}
    const next = {}
    Object.keys(value).forEach((key) => {
        const lang = normalizeUiLanguage(key, '')
        if (!lang) return
        const text = value[key]
        if (text === undefined || text === null || String(text) === '') return
        if (next[lang] === undefined || next[lang] === '') {
            next[lang] = text
        }
    })
    return next
}

export function normalizeLanguageList(list, fallbackList = []) {
    const source = Array.isArray(list) && list.length ? list : fallbackList
    const out = []
    source.forEach((item) => {
        const lang = normalizeUiLanguage(item, '')
        if (lang && !out.includes(lang)) out.push(lang)
    })
    return out
}

export function detectBrowserUiLanguage(fallback = 'en') {
    if (typeof navigator === 'undefined') return fallback
    const raw = navigator.language || navigator.userLanguage || ''
    const normalized = normalizeUiLanguage(raw, '')
    if (normalized && LANGUAGE_CODES.includes(normalized)) return normalized
    return fallback
}
